export default () => (
  <svg
    width="24"
    height="12"
    viewBox="0 0 24 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1115 2.49728C16.6972 2.08292 16.6972 1.41112 17.1115 0.996758C17.5259 0.582402 18.1977 0.582402 18.6121 0.996758L22.8562 5.24087C23.2705 5.65523 23.2705 6.32703 22.8562 6.74139L18.6121 10.9855C18.1977 11.3999 17.5259 11.3999 17.1115 10.9855C16.6972 10.5711 16.6972 9.89933 17.1115 9.48498L20.6054 5.99113L17.1115 2.49728Z"
      fill="currentColor"
    />
    <path
      d="M6.05642 2.49728C6.47078 2.08292 6.47078 1.41112 6.05642 0.996759C5.64206 0.582403 4.97026 0.582403 4.5559 0.996759L0.311791 5.24087C-0.102566 5.65523 -0.102566 6.32703 0.311791 6.74139L4.5559 10.9855C4.97026 11.3999 5.64206 11.3999 6.05642 10.9855C6.47078 10.5711 6.47078 9.89933 6.05642 9.48498L2.56257 5.99113L6.05642 2.49728Z"
      fill="currentColor"
    />
    <path
      d="M12.6739 1.45938C12.8266 0.889685 13.4122 0.551599 13.9819 0.704249C14.5109 0.845996 14.8402 1.36103 14.7623 1.89002L14.737 2.01218L10.7398 10.541C10.5871 11.1107 10.0016 11.4488 9.43185 11.2961C8.90285 11.1544 8.57355 10.6393 8.65143 10.1103L8.67672 9.98819L12.6739 1.45938Z"
      fill="currentColor"
    />
  </svg>
);
